import { Controller } from "@hotwired/stimulus";
import { hideModelingLoading, showModelingLoading } from "../scenario_modeling/payload_refresh";

export default class extends Controller {
  static targets = ["contributionCell", "volDeclaredCell", "buyingPctCell", "gtuCell"];

  static values = {
    gapTarget: { type: Number, default: 100 },
    currencyCode: String,
  };

  connect() {
    this._onGapTargetChange = this.updateGapTarget.bind(this);
    this._onExchangeRatesLoading = this.showLoading.bind(this);
    this._onExchangeRatesReady = this.hideLoading.bind(this);
    this._onExchangeRatesError = this.restoreAfterError.bind(this);

    window.addEventListener("scenario-modeling:gap-target-change", this._onGapTargetChange);
    window.addEventListener("scenario-modeling:exchange-rates-loading", this._onExchangeRatesLoading);
    window.addEventListener("scenario-modeling:exchange-rates-ready", this._onExchangeRatesReady);
    window.addEventListener("scenario-modeling:exchange-rates-error", this._onExchangeRatesError);

    const gapInput = document.getElementById("scenario_lw_gap_closure_target");
    if (gapInput) this.gapTargetValue = this._normalizeGapTarget(gapInput.value);
  }

  disconnect() {
    window.removeEventListener("scenario-modeling:gap-target-change", this._onGapTargetChange);
    window.removeEventListener("scenario-modeling:exchange-rates-loading", this._onExchangeRatesLoading);
    window.removeEventListener("scenario-modeling:exchange-rates-ready", this._onExchangeRatesReady);
    window.removeEventListener("scenario-modeling:exchange-rates-error", this._onExchangeRatesError);
  }

  updateGapTarget(event) {
    this.gapTargetValue = this._normalizeGapTarget(event.detail?.value);
    this._renderContributions();
  }

  showLoading() {
    showModelingLoading();
  }

  hideLoading() {
    hideModelingLoading();
  }

  restoreAfterError() {
    hideModelingLoading();
  }

  _renderContributions() {
    this.contributionCellTargets.forEach((cell) => {
      const gap = Number(cell.dataset.gapPayment) || 0;
      const contribution = Math.round(gap * (this.gapTargetValue / 100));
      const amount = cell.querySelector("[data-role='amount']");
      if (amount) amount.textContent = contribution.toLocaleString();
    });
  }

  _normalizeGapTarget(raw) {
    const value = parseFloat(raw);
    if (Number.isNaN(value)) return 0;

    return Math.min(100, Math.max(0, value));
  }
}
